/**
 * 尺码指南计算器 JavaScript - 女士版本
 * 提供文胸和内裤尺码计算功能
 */

// 全局函数，用于打开尺码计算器（提前定义以确保在onclick调用时可用）
if (typeof window.openBraSizeCalculator === 'undefined') {
  window.openBraSizeCalculator = function(type = 'women') {
    const modalId = type === 'men' ? 'bra-size-calculator-men' : 
                     type === 'kids' ? 'bra-size-calculator-kids' : 
                     'bra-size-calculator-women';
    
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
      // 设置 main 元素的 z-index，防止被 header 覆盖
      const mainElement = document.querySelector('.main');
      if (mainElement) {
        mainElement.style.zIndex = '501';
      }
    }
  };
}

class BraSizeCalculator {
  constructor() {
    this.modal = null;
    this.mouseDownOnContent = false; // 记录鼠标是否在弹框内容区域按下
  }

  init() {
    this.bindEvents();
    this.generateSizeTable();
    // 初始化时更新 Bra tab 的 placeholder
    const currentUnit = this.getCurrentUnit('women');
    this.updateBraInputPlaceholders(currentUnit);
  }

  bindEvents() {
    if (!this.modal) return;
    
    // 关闭模态框
    this.modal.querySelectorAll('[data-close-modal]').forEach(trigger => {
      trigger.addEventListener('click', () => this.closeModal());
    });

    // 标签页切换
    this.modal.querySelectorAll('.bra-size-calculator__tab').forEach(tab => {
      tab.addEventListener('click', (e) => {
        const tabName = e.currentTarget.getAttribute('data-tab');
        if (tabName) {
          this.switchTab(tabName);
        }
      });
    });

    // Size Type 选择器（US/UK SIZE / EU SIZE）
    const sizeTypeSelect = this.modal.querySelector('#size-type-women');
    
    if (sizeTypeSelect) {
      // 页面加载时自动触发一次，填充默认值
      const initialSizeType = sizeTypeSelect.value || 'us';
      if (initialSizeType) {
        const event = new Event('change');
        sizeTypeSelect.value = initialSizeType;
        sizeTypeSelect.dispatchEvent(event);
      }
      
      sizeTypeSelect.addEventListener('change', (e) => {
        const sizeType = e.target.value;
        if (sizeType) {
          // 根据选择的尺码类型直接填充测量值
          // 默认选择 34B 尺码（US）或 75B（EU）
          const defaultSize = sizeType === 'us' ? '34B' : '75B';
          const sizeMap = {
            '30A': { band: 25, bust: 26 },
            '30B': { band: 25, bust: 27 },
            '30C': { band: 25, bust: 28 },
            '32A': { band: 27, bust: 28 },
            '32B': { band: 27, bust: 29 },
            '32C': { band: 27, bust: 30 },
            '32D': { band: 27, bust: 31 },
            '34A': { band: 29, bust: 30 },
            '34B': { band: 29, bust: 31 },
            '34C': { band: 29, bust: 32 },
            '34D': { band: 29, bust: 33 },
            '36A': { band: 31, bust: 32 },
            '36B': { band: 31, bust: 33 },
            '36C': { band: 31, bust: 34 },
            '36D': { band: 31, bust: 35 },
            '38B': { band: 33, bust: 35 },
            '38C': { band: 33, bust: 36 },
            '38D': { band: 33, bust: 37 },
            '40C': { band: 35, bust: 38 },
            '40D': { band: 35, bust: 39 },
            '65A': { band: 25, bust: 26 },
            '65B': { band: 25, bust: 27 },
            '65C': { band: 25, bust: 28 },
            '70A': { band: 27, bust: 28 },
            '70B': { band: 27, bust: 29 },
            '70C': { band: 27, bust: 30 },
            '70D': { band: 27, bust: 31 },
            '75A': { band: 29, bust: 30 },
            '75B': { band: 29, bust: 31 },
            '75C': { band: 29, bust: 32 },
            '75D': { band: 29, bust: 33 },
            '80A': { band: 31, bust: 32 },
            '80B': { band: 31, bust: 33 },
            '80C': { band: 31, bust: 34 },
            '80D': { band: 31, bust: 35 },
            '85B': { band: 33, bust: 35 },
            '85C': { band: 33, bust: 36 },
            '85D': { band: 33, bust: 37 },
            '90C': { band: 35, bust: 38 },
            '90D': { band: 35, bust: 39 }
          };
          
          const measurements = sizeMap[defaultSize];
          if (measurements) {
            const currentUnit = this.getCurrentUnit('women');
            let bandValue = measurements.band;
            let bustValue = measurements.bust;
            
            if (currentUnit === 'cm') {
              bandValue = bandValue * 2.54;
              bustValue = bustValue * 2.54;
            }
            
            const bandInput = document.getElementById('band-measurement-women');
            const bustInput = document.getElementById('bust-measurement-women');
            if (bandInput) bandInput.value = bandValue.toFixed(1);
            if (bustInput) bustInput.value = bustValue.toFixed(1);
          }
        }
      });
    }

    // 单位切换按钮
    this.modal.querySelectorAll('[data-unit][data-type="women"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const newUnit = e.target.dataset.unit;
        this.handleUnitToggle(newUnit, 'women');
        // 切换单位时重新生成表格
        const tableBody = this.modal.querySelector('#bra-size-table-body-women');
        if (tableBody) {
          this.generateBraSizeTable(tableBody);
        }
        // 切换单位时重新生成 T-Shirts 表格
        const tshirtTableBody = this.modal.querySelector('#tshirt-size-table-body-women');
        if (tshirtTableBody) {
          this.generateTshirtSizeTable(tshirtTableBody);
        }
      });
    });

    // 计算尺码
    const calculateBtn = this.modal.querySelector('[data-calculate-bra-size-women]');
    if (calculateBtn) {
      calculateBtn.addEventListener('click', () => {
        this.calculateBraSizeWomen();
      });
    }

    // Bra tab 输入框回车键触发查询
    const bandInput = document.getElementById('band-measurement-women');
    const bustInput = document.getElementById('bust-measurement-women');
    if (bandInput) {
      bandInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.calculateBraSizeWomen();
        }
      });
    }
    if (bustInput) {
      bustInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.calculateBraSizeWomen();
        }
      });
    }


    // Panty tab 相关事件
    // Size Type 选择器（Panty）
    const sizeTypeSelectPanty = this.modal.querySelector('#size-type-women-panty');
    if (sizeTypeSelectPanty) {
      sizeTypeSelectPanty.addEventListener('change', () => {
        // 如果已有计算结果，更新显示
        const resultElement = document.getElementById('recommended-bra-size-women-panty');
        const resultContainer = document.getElementById('bra-size-result-women-panty');
        if (resultElement && resultContainer && resultContainer.style.display !== 'none' && this.recommendedPantySizeUS) {
          const sizeType = sizeTypeSelectPanty.value;
          const displaySize = sizeType === 'eu' ? this.recommendedPantySizeEU : this.recommendedPantySizeUS;
          resultElement.textContent = displaySize;
          this.recommendedPantySize = displaySize;
        }
      });
    }

    // 单位切换按钮（Panty）
    this.modal.querySelectorAll('[data-unit][data-type="women-panty"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const newUnit = e.target.dataset.unit;
        this.handleUnitToggle(newUnit, 'women-panty');
        // 切换单位时重新生成 Panty 表格
        const pantyTableBody = this.modal.querySelector('#panty-size-table-body-women');
        if (pantyTableBody) {
          this.generatePantySizeTable(pantyTableBody);
        }
      });
    });

    // 计算 Panty 尺码
    const calculatePantyBtn = this.modal.querySelector('[data-calculate-panty-size-women]');
    if (calculatePantyBtn) {
      calculatePantyBtn.addEventListener('click', () => {
        this.calculatePantySizeWomen();
      });
    }

    // Panty tab 输入框回车键触发查询
    const pantyInput = document.getElementById('measurement-women-panty');
    if (pantyInput) {
      pantyInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.calculatePantySizeWomen();
        }
      });
    }


    // Lounge & Layers tab 相关事件
    // 分类选择器（Lounge & Layers）
    const categorySelectLounge = this.modal.querySelector('#category-type-women-lounge');
    if (categorySelectLounge) {
      categorySelectLounge.addEventListener('change', () => {
        this.updateLoungeInputPlaceholder();
      });
      // 初始化时更新一次
      this.updateLoungeInputPlaceholder();
    }

    // Size Type 选择器（Lounge & Layers）
    const sizeTypeSelectLounge = this.modal.querySelector('#size-type-women-lounge');
    if (sizeTypeSelectLounge) {
      sizeTypeSelectLounge.addEventListener('change', () => {
        // 如果已有计算结果，更新显示
        const resultElement = document.getElementById('recommended-bra-size-women-lounge');
        const resultContainer = document.getElementById('bra-size-result-women-lounge');
        if (resultElement && resultContainer && resultContainer.style.display !== 'none' && this.recommendedLoungeSizeUS) {
          const sizeType = sizeTypeSelectLounge.value;
          const displaySize = sizeType === 'eu' ? this.recommendedLoungeSizeEU : this.recommendedLoungeSizeUS;
          resultElement.textContent = displaySize;
          this.recommendedLoungeSize = displaySize;
        }
      });
    }

    // 单位切换按钮（Lounge & Layers）
    this.modal.querySelectorAll('[data-unit][data-type="women-lounge"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const newUnit = e.target.dataset.unit;
        this.handleUnitToggle(newUnit, 'women-lounge');
        // 切换单位时重新生成 Lounge & Layers 表格
        const loungeTableBody = this.modal.querySelector('#lounge-size-table-body-women');
        if (loungeTableBody) {
          this.generateLoungeSizeTable(loungeTableBody);
        }
        // 更新输入框placeholder
        this.updateLoungeInputPlaceholder();
      });
    });

    // 计算 Lounge & Layers 尺码
    const calculateLoungeBtn = this.modal.querySelector('[data-calculate-lounge-size-women]');
    if (calculateLoungeBtn) {
      calculateLoungeBtn.addEventListener('click', () => {
        this.calculateLoungeSizeWomen();
      });
    }

    // Lounge & Layers tab 输入框回车键触发查询
    const loungeInput = document.getElementById('measurement-women-lounge');
    if (loungeInput) {
      loungeInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.calculateLoungeSizeWomen();
        }
      });
    }


    // ESC键关闭
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.style.display !== 'none') {
        this.closeModal();
      }
    });

    // 记录鼠标是否在弹框内容区域按下
    this.modal.addEventListener('mousedown', (e) => {
      // 如果鼠标在弹框内容区域（modal 的子元素）按下，设置标志
      this.mouseDownOnContent = e.target !== this.modal;
    });

    // 点击外部关闭（只有在遮罩层上点击且没有从内容区域拖拽过来才关闭）
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal && !this.mouseDownOnContent) {
        this.closeModal();
      }
      // 重置标志
      this.mouseDownOnContent = false;
    });
  }

  closeModal() {
    this.modal.style.display = 'none';
    document.body.style.overflow = '';
    // 恢复 main 元素的 z-index
    const mainElement = document.querySelector('.main');
    if (mainElement) {
      mainElement.style.zIndex = '';
    }
  }

  switchTab(tabName) {
    if (!this.modal) return;
    
    // 更新标签页状态
    this.modal.querySelectorAll('.bra-size-calculator__tab').forEach(tab => {
      tab.classList.remove('active');
    });
    const activeTab = this.modal.querySelector(`[data-tab="${tabName}"]`);
    if (activeTab) activeTab.classList.add('active');

    // 更新面板状态
    this.modal.querySelectorAll('.bra-size-calculator__panel').forEach(panel => {
      panel.classList.remove('active');
      panel.style.display = 'none';
    });
    const activePanel = this.modal.querySelector(`[data-panel="${tabName}"]`);
    if (activePanel) {
      activePanel.classList.add('active');
      activePanel.style.display = 'block';
    }
  }

  calculateBraSizeWomen() {
    const bandInput = document.getElementById('band-measurement-women');
    const bustInput = document.getElementById('bust-measurement-women');
    if (!bandInput || !bustInput) return;
    
    let bandMeasurement = parseFloat(bandInput.value);
    let bustMeasurement = parseFloat(bustInput.value);

    if (!bandMeasurement || !bustMeasurement) {
      alert('Please enter complete measurements');
      return;
    }

    if (bandMeasurement >= bustMeasurement) {
      alert('Bust measurement should be greater than band measurement');
      return;
    }

    // 获取当前单位（不进行转换，直接使用输入的单位）
    const currentUnit = this.getCurrentUnit('women');
    
    // 计算差值（使用原始单位，不转换）
    const difference = bustMeasurement - bandMeasurement;

    // 根据单位选择不同的数据范围进行计算
    let bandSizeUS, bandSizeEU, cupSize;
    
    if (currentUnit === 'in') {
      // INCH单位：直接使用INCH值进行计算
      // 根据下胸围（INCH）确定底围尺码
      const bandSizeData = [
        { range: [26.5, 28.5], bandSizeUS: 32, bandSizeEU: 70 },
        { range: [28.5, 30.5], bandSizeUS: 34, bandSizeEU: 75 },
        { range: [30.5, 32.4], bandSizeUS: 36, bandSizeEU: 80 },
        { range: [32.4, 34.4], bandSizeUS: 38, bandSizeEU: 85 },
        { range: [34.5, 36.4], bandSizeUS: 40, bandSizeEU: 90 },
        { range: [36.4, 38.4], bandSizeUS: 42, bandSizeEU: 95 }
      ];
      
      let bandMatch = null;
      bandSizeData.forEach((item, index) => {
        const isLastRange = index === bandSizeData.length - 1;
        if (isLastRange) {
          if (bandMeasurement >= item.range[0] && bandMeasurement <= item.range[1]) {
            bandMatch = item;
          }
        } else {
          if (bandMeasurement >= item.range[0] && bandMeasurement < item.range[1]) {
            bandMatch = item;
          }
        }
      });
      
      if (bandMatch) {
        bandSizeUS = bandMatch.bandSizeUS;
        bandSizeEU = bandMatch.bandSizeEU;
    } else {
        // 超出范围，使用最接近的尺码
        if (bandMeasurement < 26.5) {
          bandSizeUS = 32;
          bandSizeEU = 70;
        } else {
          bandSizeUS = 42;
          bandSizeEU = 95;
        }
      }

      // 根据差值（INCH）确定罩杯尺码
      const cupSizeData = [
        { range: [3, 3.9], cupSize: 'A' },
        { range: [3.9, 4.9], cupSize: 'B' },
        { range: [4.9, 5.9], cupSize: 'C' },
        { range: [5.9, 6.9], cupSize: 'D' },
        { range: [6.9, 7.9], cupSize: 'E' }
      ];
      
      let cupMatch = null;
      cupSizeData.forEach((item, index) => {
        const isLastRange = index === cupSizeData.length - 1;
        if (isLastRange) {
          if (difference >= item.range[0] && difference <= item.range[1]) {
            cupMatch = item;
          }
        } else {
          if (difference >= item.range[0] && difference < item.range[1]) {
            cupMatch = item;
          }
        }
      });
      
      if (cupMatch) {
        cupSize = cupMatch.cupSize;
    } else {
        // 超出范围
        if (difference < 3) {
          cupSize = 'A';
        } else {
          cupSize = 'E';
        }
      }
    } else {
      // CM单位：直接使用CM值进行计算
      // 根据下胸围（CM）确定底围尺码
      const bandSizeData = [
        { range: [67.5, 72.5], bandSizeUS: 32, bandSizeEU: 70 },
        { range: [72.5, 77.5], bandSizeUS: 34, bandSizeEU: 75 },
        { range: [77.5, 82.5], bandSizeUS: 36, bandSizeEU: 80 },
        { range: [82.5, 87.5], bandSizeUS: 38, bandSizeEU: 85 },
        { range: [87.5, 92.5], bandSizeUS: 40, bandSizeEU: 90 },
        { range: [92.5, 97.5], bandSizeUS: 42, bandSizeEU: 95 }
      ];
      
      let bandMatch = null;
      bandSizeData.forEach((item, index) => {
        const isLastRange = index === bandSizeData.length - 1;
        if (isLastRange) {
          if (bandMeasurement >= item.range[0] && bandMeasurement <= item.range[1]) {
            bandMatch = item;
          }
        } else {
          if (bandMeasurement >= item.range[0] && bandMeasurement < item.range[1]) {
            bandMatch = item;
          }
        }
      });
      
      if (bandMatch) {
        bandSizeUS = bandMatch.bandSizeUS;
        bandSizeEU = bandMatch.bandSizeEU;
      } else {
        // 超出范围，使用最接近的尺码
        if (bandMeasurement < 67.5) {
          bandSizeUS = 32;
          bandSizeEU = 70;
        } else {
          bandSizeUS = 42;
          bandSizeEU = 95;
        }
      }

      // 根据差值（CM）确定罩杯尺码
      const cupSizeData = [
        { range: [7.5, 10], cupSize: 'A' },
        { range: [10, 12.5], cupSize: 'B' },
        { range: [12.5, 15], cupSize: 'C' },
        { range: [15, 17.5], cupSize: 'D' },
        { range: [17.5, 20], cupSize: 'E' }
      ];
      
      let cupMatch = null;
      cupSizeData.forEach((item, index) => {
        const isLastRange = index === cupSizeData.length - 1;
        if (isLastRange) {
          if (difference >= item.range[0] && difference <= item.range[1]) {
            cupMatch = item;
          }
        } else {
          if (difference >= item.range[0] && difference < item.range[1]) {
            cupMatch = item;
          }
        }
      });
      
      if (cupMatch) {
        cupSize = cupMatch.cupSize;
      } else {
        // 超出范围
        if (difference < 7.5) {
          cupSize = 'A';
        } else {
          cupSize = 'E';
        }
      }
    }

    // 获取当前选择的尺码类型（US 或 EU）
    const sizeTypeSelect = document.getElementById('size-type-women');
    const sizeType = sizeTypeSelect ? sizeTypeSelect.value : 'us';
    
    let recommendedSize;
    if (sizeType === 'eu') {
      recommendedSize = `${cupSize}${bandSizeEU}`;
    } else {
      recommendedSize = `${bandSizeUS}${cupSize}`;
    }
    
    // 显示结果
    const resultElement = document.getElementById('recommended-bra-size-women');
    const resultContainer = document.getElementById('bra-size-result-women');
    
    if (resultElement) resultElement.textContent = recommendedSize;
    if (resultContainer) resultContainer.style.display = 'block';
    
    // 存储推荐尺码供后续使用
    this.recommendedSize = recommendedSize;
    this.recommendedBandSize = sizeType === 'eu' ? bandSizeEU : bandSizeUS;
    this.recommendedCupSize = cupSize;

    // 滚动到结果
    const scrollTarget = document.getElementById('bra-size-result-women');
    if (scrollTarget) {
      scrollTarget.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'center' 
    });
    }
  }


  calculatePantySizeWomen() {
    const input = document.getElementById('measurement-women-panty');
    if (!input) return;
    
    let measurement = parseFloat(input.value);
    
    if (!measurement || isNaN(measurement)) {
      alert('Please enter a measurement');
      return;
    }

    // 获取当前单位和尺码类型（固定使用 waist）
    const currentUnit = this.getCurrentUnit('women-panty');
    const category = 'waist'; // 固定使用 waist
    const sizeTypeSelect = document.getElementById('size-type-women-panty');
    const sizeType = sizeTypeSelect ? sizeTypeSelect.value : 'us';
    
    // 获取表格数据（基于当前单位）
    let sizeData;
    if (currentUnit === 'in') {
      sizeData = [
        { sizeUS: 'XS', sizeEU: '34', waistRange: [24, 26.5] },
        { sizeUS: 'S', sizeEU: '36', waistRange: [26.5, 29] },
        { sizeUS: 'M', sizeEU: '38', waistRange: [29, 31] },
        { sizeUS: 'L', sizeEU: '40', waistRange: [31, 33.5] },
        { sizeUS: 'XL', sizeEU: '42', waistRange: [33.5, 36] }
      ];
    } else {
      sizeData = [
        { sizeUS: 'XS', sizeEU: '34', waistRange: [61, 67] },
        { sizeUS: 'S', sizeEU: '36', waistRange: [67, 73] },
        { sizeUS: 'M', sizeEU: '38', waistRange: [73, 79] },
        { sizeUS: 'L', sizeEU: '40', waistRange: [79, 85] },
        { sizeUS: 'XL', sizeEU: '42', waistRange: [85, 91] }
      ];
    }

    // 根据 waist 匹配对应的范围
    let bestMatch = null;
    let bestScore = 0;
    const tolerance = currentUnit === 'in' ? 0.5 : 2;

    sizeData.forEach((sizeInfo, index) => {
      let score = 0;
      const range = sizeInfo.waistRange;
      const isLastRange = index === sizeData.length - 1; // 是否是最后一个范围
      
      // 检查是否在范围内（最后一个范围使用 <=，其他使用 <）
      if (isLastRange) {
      if (measurement >= range[0] && measurement <= range[1]) {
        score = 10; // 精确匹配
      } else if (measurement >= range[0] - tolerance && measurement <= range[1] + tolerance) {
        score = 5; // 接近范围
      } else {
        // 计算距离
        const mid = (range[0] + range[1]) / 2;
        const dist = Math.abs(measurement - mid);
        score = Math.max(0, 5 - dist);
        }
      } else {
        if (measurement >= range[0] && measurement < range[1]) {
          score = 10; // 精确匹配
        } else if (measurement >= range[0] - tolerance && measurement < range[1] + tolerance) {
          score = 5; // 接近范围
        } else {
          // 计算距离
          const mid = (range[0] + range[1]) / 2;
          const dist = Math.abs(measurement - mid);
          score = Math.max(0, 5 - dist);
        }
      }
      
      if (score > bestScore) {
        bestScore = score;
        bestMatch = sizeInfo;
      }
    });

    // 如果没有找到匹配，使用最接近的范围
    if (!bestMatch) {
      sizeData.forEach(sizeInfo => {
        const range = sizeInfo.waistRange;
        const mid = (range[0] + range[1]) / 2;
        const dist = Math.abs(measurement - mid);
        
        if (!bestMatch || dist < bestScore) {
          bestScore = dist;
          bestMatch = sizeInfo;
          }
        });
      }

    if (!bestMatch) {
      alert('Unable to determine size. Please check your measurement.');
      return;
    }

    // 根据US/EU显示对应的尺码
    const displaySize = sizeType === 'eu' ? bestMatch.sizeEU : bestMatch.sizeUS;

    // 显示结果
    const resultElement = document.getElementById('recommended-bra-size-women-panty');
    const resultContainer = document.getElementById('bra-size-result-women-panty');
    
    if (resultElement) resultElement.textContent = displaySize;
    if (resultContainer) resultContainer.style.display = 'block';
    
    // 存储推荐尺码供后续使用
    this.recommendedPantySize = displaySize;
    this.recommendedPantySizeUS = bestMatch.sizeUS;
    this.recommendedPantySizeEU = bestMatch.sizeEU;

    // 滚动到结果
    const scrollTarget = document.getElementById('bra-size-result-women-panty');
    if (scrollTarget) {
      scrollTarget.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    }
  }


  calculateLoungeSizeWomen() {
    const input = document.getElementById('measurement-women-lounge');
    if (!input) return;
    
    let measurement = parseFloat(input.value);
    
    if (!measurement || isNaN(measurement)) {
      alert('Please enter a measurement');
      return;
    }

    // 获取当前单位、分类和尺码类型
    const currentUnit = this.getCurrentUnit('women-lounge');
    const categorySelect = document.getElementById('category-type-women-lounge');
    const category = categorySelect ? categorySelect.value : 'height';
    const sizeTypeSelect = document.getElementById('size-type-women-lounge');
    const sizeType = sizeTypeSelect ? sizeTypeSelect.value : 'us';
    
    // 获取表格数据（基于当前单位）
    let sizeData;
    if (currentUnit === 'in') {
      sizeData = [
        { sizeUS: 'XS', sizeEU: '34', heightRange: [61, 63], bustRange: [30, 32], waistRange: [24, 26.5] },
        { sizeUS: 'S', sizeEU: '36', heightRange: [63, 65], bustRange: [32, 34], waistRange: [26.5, 29] },
        { sizeUS: 'M', sizeEU: '38', heightRange: [65, 67], bustRange: [34, 36], waistRange: [29, 31] },
        { sizeUS: 'L', sizeEU: '40', heightRange: [67, 69], bustRange: [36, 38], waistRange: [31, 33.5] },
        { sizeUS: 'XL', sizeEU: '42', heightRange: [69, 71], bustRange: [38, 40], waistRange: [33.5, 36] }
      ];
    } else {
      sizeData = [
        { sizeUS: 'XS', sizeEU: '34', heightRange: [155, 160], bustRange: [77, 82], waistRange: [61, 67] },
        { sizeUS: 'S', sizeEU: '36', heightRange: [160, 165], bustRange: [82, 87], waistRange: [67, 73] },
        { sizeUS: 'M', sizeEU: '38', heightRange: [165, 170], bustRange: [87, 92], waistRange: [73, 79] },
        { sizeUS: 'L', sizeEU: '40', heightRange: [170, 175], bustRange: [92, 97], waistRange: [79, 85] },
        { sizeUS: 'XL', sizeEU: '42', heightRange: [175, 180], bustRange: [97, 102], waistRange: [85, 91] }
      ];
    }

    // 根据选择的分类匹配对应的范围
    let bestMatch = null;
    let bestScore = 0;
    const tolerance = currentUnit === 'in' ? 0.5 : 2;

    sizeData.forEach((sizeInfo, index) => {
      let score = 0;
      let range;
      if (category === 'height') {
        range = sizeInfo.heightRange;
      } else if (category === 'bust') {
        range = sizeInfo.bustRange;
      } else if (category === 'waist') {
        range = sizeInfo.waistRange;
      } else {
        return;
      }
      
      const isLastRange = index === sizeData.length - 1; // 是否是最后一个范围
      
      // 检查是否在范围内（最后一个范围使用 <=，其他使用 <）
      if (isLastRange) {
      if (measurement >= range[0] && measurement <= range[1]) {
        score = 10; // 精确匹配
      } else if (measurement >= range[0] - tolerance && measurement <= range[1] + tolerance) {
        score = 5; // 接近范围
      } else {
        // 计算距离
        const mid = (range[0] + range[1]) / 2;
        const dist = Math.abs(measurement - mid);
        score = Math.max(0, 5 - dist);
        }
      } else {
        if (measurement >= range[0] && measurement < range[1]) {
          score = 10; // 精确匹配
        } else if (measurement >= range[0] - tolerance && measurement < range[1] + tolerance) {
          score = 5; // 接近范围
        } else {
          // 计算距离
          const mid = (range[0] + range[1]) / 2;
          const dist = Math.abs(measurement - mid);
          score = Math.max(0, 5 - dist);
        }
      }
      
      if (score > bestScore) {
        bestScore = score;
        bestMatch = sizeInfo;
      }
    });

    // 如果没有找到匹配，使用最接近的范围
    if (!bestMatch) {
      sizeData.forEach(sizeInfo => {
        let range;
        if (category === 'height') {
          range = sizeInfo.heightRange;
        } else if (category === 'bust') {
          range = sizeInfo.bustRange;
        } else if (category === 'waist') {
          range = sizeInfo.waistRange;
        } else {
          return;
        }
        
        const mid = (range[0] + range[1]) / 2;
        const dist = Math.abs(measurement - mid);
        
        if (!bestMatch || dist < bestScore) {
          bestScore = dist;
          bestMatch = sizeInfo;
        }
      });
    }

    if (!bestMatch) {
      alert('Unable to determine size. Please check your measurement.');
      return;
    }

    // 根据US/EU显示对应的尺码
    const recommendedSize = sizeType === 'eu' ? bestMatch.sizeEU : bestMatch.sizeUS;
    
    // 显示结果
    const resultElement = document.getElementById('recommended-bra-size-women-lounge');
    const resultContainer = document.getElementById('bra-size-result-women-lounge');
    
    if (resultElement) resultElement.textContent = recommendedSize;
    if (resultContainer) resultContainer.style.display = 'block';
    
    // 存储推荐尺码供后续使用
    this.recommendedLoungeSize = recommendedSize;
    this.recommendedLoungeSizeUS = bestMatch.sizeUS;
    this.recommendedLoungeSizeEU = bestMatch.sizeEU;

    // 滚动到结果
    const scrollTarget = document.getElementById('bra-size-result-women-lounge');
    if (scrollTarget) {
      scrollTarget.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    }
  }
  generateSizeTable() {
    // 生成文胸尺码表中的表格
    const tableBody = this.modal ? 
      this.modal.querySelector('#bra-size-table-body-women') :
      document.getElementById('bra-size-table-body-women');
    this.generateBraSizeTable(tableBody);
    
    // 生成 T-Shirts Bra Size Chart 表格
    const tshirtTableBody = this.modal ? 
      this.modal.querySelector('#tshirt-size-table-body-women') :
      document.getElementById('tshirt-size-table-body-women');
    if (tshirtTableBody) {
      this.generateTshirtSizeTable(tshirtTableBody);
    }
    
    // 生成 Panty Size Chart 表格
    const pantyTableBody = this.modal ? 
      this.modal.querySelector('#panty-size-table-body-women') :
      document.getElementById('panty-size-table-body-women');
    if (pantyTableBody) {
      this.generatePantySizeTable(pantyTableBody);
    }
    
    // 生成 Lounge & Layers Size Chart 表格
    const loungeTableBody = this.modal ? 
      this.modal.querySelector('#lounge-size-table-body-women') :
      document.getElementById('lounge-size-table-body-women');
    if (loungeTableBody) {
      this.generateLoungeSizeTable(loungeTableBody);
    }
  }

  // 获取当前单位
  getCurrentUnit(type) {
    const activeBtn = document.querySelector(`[data-type="${type}"].bra-size-calculator__unit-btn.active`);
    return activeBtn ? activeBtn.dataset.unit : 'in';
  }

  // 处理单位切换
  handleUnitToggle(unit, type) {
    // 更新按钮状态
    const unitBtns = document.querySelectorAll(`[data-type="${type}"].bra-size-calculator__unit-btn`);
    unitBtns.forEach(btn => {
      btn.classList.remove('active');
      if (btn.dataset.unit === unit) {
        btn.classList.add('active');
      }
    });

    // 更新标签
    if (type === 'women-panty') {
      const unitLabelsPanty = document.querySelectorAll('.unit-label-women-panty');
      const unitTextPanty = unit === 'cm' ? 'cm' : 'inches';
      unitLabelsPanty.forEach(label => {
        label.textContent = unitTextPanty;
      });
    } else if (type === 'women-lounge') {
      const unitLabelsLounge = document.querySelectorAll('.unit-label-women-lounge');
      const unitTextLounge = unit === 'cm' ? 'cm' : 'inches';
      unitLabelsLounge.forEach(label => {
        label.textContent = unitTextLounge;
      });
    } else {
      const unitLabels = document.querySelectorAll(`.unit-label-${type}`);
      const unitText = unit === 'cm' ? 'cm' : 'inches';
      unitLabels.forEach(label => {
        label.textContent = unitText;
      });
    }

    // 转换输入框的值
    if (type === 'women') {
      this.convertInputValues('band-measurement-women', unit);
      this.convertInputValues('bust-measurement-women', unit);
      // 更新 Bra tab 的 placeholder
      this.updateBraInputPlaceholders(unit);
    } else if (type === 'women-panty') {
      this.convertInputValues('measurement-women-panty', unit);
    } else if (type === 'women-lounge') {
      this.convertInputValues('measurement-women-lounge', unit);
      this.updateLoungeInputPlaceholder();
    } else if (type === 'kids') {
      this.convertInputValues('height-measurement-kids', unit);
      // Weight 不需要转换，因为单位是 lbs/kg
    }

    // 更新输入框的 data-unit 属性
    const inputs = document.querySelectorAll(`[data-type="${type}"] input[data-unit]`);
    inputs.forEach(input => {
      if (input.dataset.unit === 'in' || input.dataset.unit === 'cm') {
        input.dataset.unit = unit;
      }
    });
  }

  // 转换输入框值
  convertInputValues(inputId, targetUnit) {
    const input = document.getElementById(inputId);
    if (!input || !input.value) return;

    const currentValue = parseFloat(input.value);
    if (isNaN(currentValue)) return;

    const currentUnit = input.dataset.unit || 'in';
    
    if (currentUnit === targetUnit) return;

    let convertedValue;
    if (currentUnit === 'in' && targetUnit === 'cm') {
      convertedValue = currentValue * 2.54;
    } else if (currentUnit === 'cm' && targetUnit === 'in') {
      convertedValue = currentValue / 2.54;
    } else {
      return;
    }

    input.value = convertedValue.toFixed(1);
    input.dataset.unit = targetUnit;
  }

  updateLoungeInputPlaceholder() {
    const categorySelect = document.getElementById('category-type-women-lounge');
    const input = document.getElementById('measurement-women-lounge');
    const currentUnit = this.getCurrentUnit('women-lounge');
    
    if (!categorySelect || !input) return;
    
    const category = categorySelect.value;
    const unitText = currentUnit === 'cm' ? 'cm' : 'inches';
    
    let placeholderText;
    if (category === 'height') {
      placeholderText = `Height measurement (${unitText})`;
    } else if (category === 'bust') {
      placeholderText = `Bust measurement (${unitText})`;
    } else if (category === 'waist') {
      placeholderText = `Waist measurement (${unitText})`;
    }
    
    if (placeholderText) {
      input.placeholder = placeholderText;
    }
  }

  updateBraInputPlaceholders(unit) {
    const bandInput = document.getElementById('band-measurement-women');
    const bustInput = document.getElementById('bust-measurement-women');
    const unitText = unit === 'cm' ? 'cm' : 'inches';
    
    if (bandInput) {
      bandInput.placeholder = `Band measurement (${unitText})`;
    }
    
    if (bustInput) {
      bustInput.placeholder = `Bust measurement (${unitText})`;
    }
  }

  generateBraSizeTable(tableBody) {
    if (!tableBody) return;
    
    // 获取当前单位
    const currentUnit = this.getCurrentUnit('women');
    
    // 根据单位选择不同的数据
    let sizeData, unitLabel;
    if (currentUnit === 'in') {
      // INCH 单位的数据
      sizeData = [
        { bandRange: '26.5"-28.5"', bandSizeUS: 32, bandSizeEU: 70 },
        { bandRange: '28.5"-30.5"', bandSizeUS: 34, bandSizeEU: 75 },
        { bandRange: '30.5"-32.4"', bandSizeUS: 36, bandSizeEU: 80 },
        { bandRange: '32.4"-34.4"', bandSizeUS: 38, bandSizeEU: 85 },
        { bandRange: '34.5"-36.4"', bandSizeUS: 40, bandSizeEU: 90 },
        { bandRange: '36.4"-38.4"', bandSizeUS: 42, bandSizeEU: 95 }
      ];
      unitLabel = 'INCH';
    } else {
      // CM 单位的数据（默认）
      sizeData = [
        { bandRange: '67.5-72.5', bandSizeUS: 32, bandSizeEU: 70 },
        { bandRange: '72.5-77.5', bandSizeUS: 34, bandSizeEU: 75 },
        { bandRange: '77.5-82.5', bandSizeUS: 36, bandSizeEU: 80 },
        { bandRange: '82.5-87.5', bandSizeUS: 38, bandSizeEU: 85 },
        { bandRange: '87.5-92.5', bandSizeUS: 40, bandSizeEU: 90 },
        { bandRange: '92.5-97.5', bandSizeUS: 42, bandSizeEU: 95 }
      ];
      unitLabel = 'CM';
    }

    const cupSizes = ['A', 'B', 'C', 'D', 'E'];

    // 清空现有内容
    tableBody.innerHTML = '';

    sizeData.forEach(({ bandRange, bandSizeUS, bandSizeEU }) => {
      const row = document.createElement('tr');
      
      // 第一列和第二列：BAND 范围（占据2列）
      const bandCell = document.createElement('td');
      bandCell.setAttribute('colspan', '2');
      bandCell.textContent = bandRange;
      bandCell.style.textAlign = 'center';
      bandCell.style.fontWeight = '500';
      row.appendChild(bandCell);

      // US/UK SIZE 列（5列）
      cupSizes.forEach((cupSize) => {
        const cell = document.createElement('td');
        cell.textContent = `${bandSizeUS}${cupSize}`;
        cell.style.textAlign = 'center';
        row.appendChild(cell);
      });

      // EU SIZE 列（5列）
      cupSizes.forEach((cupSize, cupIndex) => {
        const cell = document.createElement('td');
        cell.textContent = `${cupSize}${bandSizeEU}`;
        cell.style.textAlign = 'center';
        // 给 EU SIZE 的第一列添加 class
        if (cupIndex === 0) {
          cell.className = 'eu-size-first-cell-women';
        }
        row.appendChild(cell);
      });

      tableBody.appendChild(row);
    });

    // 更新表头
    this.updateBraSizeTableHeader(currentUnit);
  }

  updateBraSizeTableHeader(unit) {
    const bandHeader = document.getElementById('band-header-women');
    const differenceHeader = document.getElementById('difference-header-women');
    const differenceRangesRow = document.getElementById('difference-ranges-row-women');
    
    if (!bandHeader || !differenceHeader || !differenceRangesRow) return;

    if (unit === 'in') {
      // INCH 单位
      bandHeader.textContent = 'Band (INCH)';
      differenceHeader.textContent = 'DIFFERENCE BETWEEN BUST AND BAND MEASUREMENT (INCH)';
      
      // 更新差值范围（通过div查找span）
      const ranges = ['3"-3.9"', '3.9"-4.9"', '4.9"-5.9"', '5.9"-6.9"', '6.9"-7.9"'];
      const rangesDiv = differenceRangesRow.querySelector('.bra-size-calculator__ranges-th');
      if (rangesDiv) {
        const spans = rangesDiv.querySelectorAll('span');
      ranges.forEach((range, index) => {
          if (spans[index]) {
            spans[index].textContent = range;
          }
      });
      }
        } else {
      // CM 单位
      bandHeader.textContent = 'BAND (CM)';
      differenceHeader.textContent = 'DIFFERENCE BETWEEN BUST AND BAND MEASUREMENT (CM)';
      
      // 更新差值范围（通过div查找span）
      const ranges = ['7.5-10', '10-12.5', '12.5-15', '15-17.5', '17.5-20'];
      const rangesDiv = differenceRangesRow.querySelector('.bra-size-calculator__ranges-th');
      if (rangesDiv) {
        const spans = rangesDiv.querySelectorAll('span');
      ranges.forEach((range, index) => {
          if (spans[index]) {
            spans[index].textContent = range;
          }
      });
      }
    }
  }

  generateTshirtSizeTable(tableBody) {
    if (!tableBody) return;
    
    // 获取当前单位
    const currentUnit = this.getCurrentUnit('women');
    
    // 根据单位选择不同的数据
    let sizeData;
    if (currentUnit === 'in') {
      // INCH 单位的数据
      sizeData = [
        { sizeUS: 'XS', sizeEU: '34', bandRange: '22.6"-28.5"', differenceRange: '3"-6.9"' },
        { sizeUS: 'S', sizeEU: '36', bandRange: '28.5"-30.5"', differenceRange: '3"-6.9"' },
        { sizeUS: 'M', sizeEU: '38', bandRange: '30.5"-32.4"', differenceRange: '3"-6.9"' },
        { sizeUS: 'L', sizeEU: '40', bandRange: '32.4"-34.4"', differenceRange: '3"-6.9"' },
        { sizeUS: 'XL', sizeEU: '42', bandRange: '34.5"-36.4"', differenceRange: '3"-6.9"' }
      ];
    } else {
      // CM 单位的数据（默认）
      sizeData = [
        { sizeUS: 'XS', sizeEU: '34', bandRange: '67.5-72.5', differenceRange: '7.5-17.5' },
        { sizeUS: 'S', sizeEU: '36', bandRange: '72.5-77.5', differenceRange: '7.5-17.5' },
        { sizeUS: 'M', sizeEU: '38', bandRange: '77.5-82.5', differenceRange: '7.5-17.5' },
        { sizeUS: 'L', sizeEU: '40', bandRange: '82.5-87.5', differenceRange: '7.5-17.5' },
        { sizeUS: 'XL', sizeEU: '42', bandRange: '87.5-92.5', differenceRange: '7.5-17.5' }
      ];
    }

    // 清空现有内容
    tableBody.innerHTML = '';

    sizeData.forEach(({ sizeUS, sizeEU, bandRange, differenceRange }, index) => {
      const row = document.createElement('tr');
      
      // US/UK SIZE
      const sizeUSCell = document.createElement('td');
      sizeUSCell.textContent = sizeUS;
      sizeUSCell.style.textAlign = 'center';
      // 第一行设置列宽，其他行继承
      if (index === 0) {
        sizeUSCell.style.width = '15%';
      }
      row.appendChild(sizeUSCell);
      
      // EU SIZE
      const sizeEUCell = document.createElement('td');
      sizeEUCell.textContent = sizeEU;
      sizeEUCell.style.textAlign = 'center';
      // 第一行设置列宽，其他行继承
      if (index === 0) {
        sizeEUCell.style.width = '15%';
      }
      row.appendChild(sizeEUCell);
      
      // Band 范围
      const bandCell = document.createElement('td');
      bandCell.textContent = bandRange;
      bandCell.style.textAlign = 'center';
      // 第一行设置列宽，其他行继承
      if (index === 0) {
        bandCell.style.width = '25%';
      }
      row.appendChild(bandCell);
      
      // DIFFERENCE 范围
      const differenceCell = document.createElement('td');
      differenceCell.textContent = differenceRange;
      differenceCell.style.textAlign = 'center';
      // 第一行设置列宽，其他行继承
      if (index === 0) {
        differenceCell.style.width = '45%';
      }
      row.appendChild(differenceCell);

      tableBody.appendChild(row);
    });

    // 更新表头
    this.updateTshirtSizeTableHeader(currentUnit);
  }

  updateTshirtSizeTableHeader(unit) {
    const bandHeader = document.getElementById('tshirt-band-header-women');
    const differenceHeader = document.getElementById('tshirt-difference-header-women');
    
    if (!bandHeader || !differenceHeader) return;

    // 获取表头行，设置列宽
    const headerRow = bandHeader.parentElement;
    if (headerRow) {
      const headers = headerRow.querySelectorAll('th');
      if (headers.length >= 4) {
        headers[0].style.width = '15%'; // US/UK SIZE
        headers[1].style.width = '15%'; // EU SIZE
        headers[2].style.width = '25%'; // Band
        headers[3].style.width = '45%'; // DIFFERENCE
      }
    }

    if (unit === 'in') {
      // INCH 单位
      bandHeader.innerHTML = 'Band (INCH)';
      differenceHeader.textContent = 'DIFFERENCE BETWEEN BUST AND BAND MEASUREMENT (INCH)';
    } else {
      // CM 单位
      bandHeader.innerHTML = 'Band (CM)';
      differenceHeader.textContent = 'DIFFERENCE BETWEEN BUST AND BAND MEASUREMENT (CM)';
    }
  }

  generatePantySizeTable(tableBody) {
    if (!tableBody) return;
    
    // 获取当前单位（Panty tab 的单位）
    const currentUnit = this.getCurrentUnit('women-panty');
    
    // 根据单位选择不同的数据
    let sizeData;
    if (currentUnit === 'in') {
      // INCH 单位的数据
      sizeData = [
        { sizeUS: 'XS', sizeEU: '34', waistRange: '24-26.5', hipsRange: '31-35' },
        { sizeUS: 'S', sizeEU: '36', waistRange: '26.5-29', hipsRange: '33-37' },
        { sizeUS: 'M', sizeEU: '38', waistRange: '29-31', hipsRange: '35-39' },
        { sizeUS: 'L', sizeEU: '40', waistRange: '31-33.5', hipsRange: '37-41' },
        { sizeUS: 'XL', sizeEU: '42', waistRange: '33.5-36', hipsRange: '39-43' }
      ];
    } else {
      // CM 单位的数据（默认）
      sizeData = [
        { sizeUS: 'XS', sizeEU: '34', waistRange: '61-67', hipsRange: '80-88' },
        { sizeUS: 'S', sizeEU: '36', waistRange: '67-73', hipsRange: '85-93' },
        { sizeUS: 'M', sizeEU: '38', waistRange: '73-79', hipsRange: '90-98' },
        { sizeUS: 'L', sizeEU: '40', waistRange: '79-85', hipsRange: '95-103' },
        { sizeUS: 'XL', sizeEU: '42', waistRange: '85-91', hipsRange: '100-108' }
      ];
    }

    // 清空现有内容
    tableBody.innerHTML = '';

    sizeData.forEach(({ sizeUS, sizeEU, waistRange, hipsRange }) => {
      const row = document.createElement('tr');
      
      // US/UK SIZE
      const sizeUSCell = document.createElement('td');
      sizeUSCell.textContent = sizeUS;
      row.appendChild(sizeUSCell);
      
      // EU SIZE
      const sizeEUCell = document.createElement('td');
      sizeEUCell.textContent = sizeEU;
      row.appendChild(sizeEUCell);
      
      // Waist 范围
      const waistCell = document.createElement('td');
      waistCell.textContent = waistRange;
      row.appendChild(waistCell);
      
      // Hips 范围
      const hipsCell = document.createElement('td');
      hipsCell.textContent = hipsRange;
      row.appendChild(hipsCell);

      tableBody.appendChild(row);
    });

    // 更新表头
    this.updatePantySizeTableHeader(currentUnit);
  }

  updatePantySizeTableHeader(unit) {
    const waistHeader = document.getElementById('panty-waist-header-women');
    const hipsHeader = document.getElementById('panty-hips-header-women');
    
    if (!waistHeader || !hipsHeader) return;

    if (unit === 'in') {
      // INCH 单位
      waistHeader.textContent = 'Waist (INCH)';
      hipsHeader.textContent = 'Hips (INCH)';
    } else {
      // CM 单位
      waistHeader.textContent = 'Waist (CM)';
      hipsHeader.textContent = 'Hips (CM)';
    }
  }

  generateLoungeSizeTable(tableBody) {
    if (!tableBody) return;
    
    // 获取当前单位（Lounge & Layers tab 的单位）
    const currentUnit = this.getCurrentUnit('women-lounge');
    
    // 根据单位选择不同的数据
    let sizeData;
    if (currentUnit === 'in') {
      // INCH 单位的数据
      sizeData = [
        { sizeUS: 'XS', sizeEU: '34', heightRange: '61-63', bustRange: '30-32', waistRange: '24-26.5', hipsRange: '31-35' },
        { sizeUS: 'S', sizeEU: '36', heightRange: '63-65', bustRange: '32-34', waistRange: '26.5-29', hipsRange: '33-37' },
        { sizeUS: 'M', sizeEU: '38', heightRange: '65-67', bustRange: '34-36', waistRange: '29-31', hipsRange: '35-39' },
        { sizeUS: 'L', sizeEU: '40', heightRange: '67-69', bustRange: '36-38', waistRange: '31-33.5', hipsRange: '37-41' },
        { sizeUS: 'XL', sizeEU: '42', heightRange: '69-71', bustRange: '38-40', waistRange: '33.5-36', hipsRange: '39-43' }
      ];
    } else {
      // CM 单位的数据（默认）
      sizeData = [
        { sizeUS: 'XS', sizeEU: '34', heightRange: '155-160', bustRange: '77-82', waistRange: '61-67', hipsRange: '80-88' },
        { sizeUS: 'S', sizeEU: '36', heightRange: '160-165', bustRange: '82-87', waistRange: '67-73', hipsRange: '85-93' },
        { sizeUS: 'M', sizeEU: '38', heightRange: '165-170', bustRange: '87-92', waistRange: '73-79', hipsRange: '90-98' },
        { sizeUS: 'L', sizeEU: '40', heightRange: '170-175', bustRange: '92-97', waistRange: '79-85', hipsRange: '95-103' },
        { sizeUS: 'XL', sizeEU: '42', heightRange: '175-180', bustRange: '97-102', waistRange: '85-91', hipsRange: '100-108' }
      ];
    }

    // 清空现有内容
    tableBody.innerHTML = '';

    sizeData.forEach(({ sizeUS, sizeEU, heightRange, bustRange, waistRange, hipsRange }) => {
      const row = document.createElement('tr');
      
      // US/UK SIZE
      const sizeUSCell = document.createElement('td');
      sizeUSCell.textContent = sizeUS;
      row.appendChild(sizeUSCell);
      
      // EU SIZE
      const sizeEUCell = document.createElement('td');
      sizeEUCell.textContent = sizeEU;
      row.appendChild(sizeEUCell);
      
      // Height 范围
      const heightCell = document.createElement('td');
      heightCell.textContent = heightRange;
      row.appendChild(heightCell);
      
      // BUST 范围
      const bustCell = document.createElement('td');
      bustCell.textContent = bustRange;
      row.appendChild(bustCell);
      
      // Waist 范围
      const waistCell = document.createElement('td');
      waistCell.textContent = waistRange;
      row.appendChild(waistCell);
      
      // Hips 范围
      const hipsCell = document.createElement('td');
      hipsCell.textContent = hipsRange;
      row.appendChild(hipsCell);

      tableBody.appendChild(row);
    });

    // 更新表头
    this.updateLoungeSizeTableHeader(currentUnit);
  }

  updateLoungeSizeTableHeader(unit) {
    const heightHeader = document.getElementById('lounge-height-header-women');
    const bustHeader = document.getElementById('lounge-bust-header-women');
    const waistHeader = document.getElementById('lounge-waist-header-women');
    const hipsHeader = document.getElementById('lounge-hips-header-women');
    
    if (!heightHeader || !bustHeader || !waistHeader || !hipsHeader) return;

    if (unit === 'in') {
      // INCH 单位
      heightHeader.textContent = 'Height (INCH)';
      bustHeader.textContent = 'Bust (INCH)';
      waistHeader.textContent = 'Waist (INCH)';
      hipsHeader.textContent = 'Hips (INCH)';
    } else {
      // CM 单位
      heightHeader.textContent = 'Height (CM)';
      bustHeader.textContent = 'Bust (CM)';
      waistHeader.textContent = 'Waist (CM)';
      hipsHeader.textContent = 'Hips (CM)';
    }
  }
}

// 初始化女士尺码计算器
document.addEventListener('DOMContentLoaded', () => {
  const womenModal = document.getElementById('bra-size-calculator-women');
  if (womenModal) {
    window.braSizeCalculatorWomen = new BraSizeCalculator();
    window.braSizeCalculatorWomen.modal = womenModal;
    window.braSizeCalculatorWomen.type = 'women';
    window.braSizeCalculatorWomen.init();
  }
});
